import PropTypes from 'prop-types';
import Container from '@/components/Container';
import Spinner from '@/components/Spinner';

const defaultProps = {};

const propTypes = {
  children: PropTypes.node.isRequired,
};

export default function RedirectLayout({ children }) {
  return (
    <div className="bg-gray-100">
      <Container>
        <div className="flex w-full items-center justify-center py-10 lg:py-20">
          <div className="flex flex-col items-center space-y-4 text-gray-600">
            <Spinner size="w-10 h-10" show inverse />
            <h2 className="mx-auto max-w-screen-md text-center font-medium">
              Esta dirección ha cambiado
              <div className="text-sm text-gray-500">
                Le estamos redireccionando a la nueva dirección.
              </div>
            </h2>
            {children}
          </div>
        </div>
      </Container>
    </div>
  );
}

RedirectLayout.defaultProps = defaultProps;
RedirectLayout.propTypes = propTypes;
